import { Outlet } from "react-router-dom";

const ContactsParentPage = () => {
    return <Outlet />
}
export default ContactsParentPage;